import { render, staticRenderFns } from "./TabSelect.vue?vue&type=template&id=ab30775c&"
import script from "./TabSelect.vue?vue&type=script&lang=js&"
export * from "./TabSelect.vue?vue&type=script&lang=js&"
import style0 from "./TabSelect.vue?vue&type=style&index=0&id=ab30775c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports